import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Archive {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let filter = {};
    let type;
    let nbCardsTab1 = parseInt(document.querySelector('.archive_wrap').dataset.nb);
    let nbCardsTab2;
    let tab1 = true;
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-archive');
      cache.tabs = document.querySelectorAll('.tab_wrap .tab');
      cache.postContainer1 = document.querySelector('.post-container.part1');
      cache.postContainer2 = document.querySelector('.post-container.part2');
      cache.cards = cache.postContainer1.querySelectorAll('.shop_card');

      cache.filters = document.querySelectorAll('.filter_tag');
      cache.filterDropBtn = document.querySelector('.drop_filter');
      cache.filterDrop = document.querySelector('.filter_inner');

      if(document.querySelector(".archive-shopping")) {
        type = "cat_temp";
      } else if(document.querySelector(".archive-fooding")) {
        type = "cat_foodhall";
      }

      nbCardsTab2 = cache.postContainer1.querySelectorAll('.shop_card.'+type).length;
    };

    let registerEvents = () => {
      for (let i = 0; i < cache.tabs.length; i++) {
        cache.tabs[i].addEventListener("click", switchTab);
      }
      for (var i = 0; i < cache.filters.length; i++) {
        cache.filters[i].addEventListener("click", filterPost);
      }
      cache.filterDropBtn.addEventListener("click", openFilter);

      if(window.location.hash == "#pop-up" || window.location.hash == "#popup" || window.location.hash == "#ephemere" || window.location.hash == "#boutique" || window.location.hash == "#foodhall" || window.location.hash == "#food-hall" ) {
        cache.tabs[1].click();
        anime({
          targets: globalVar.scrollElement,
          duration: 400,
          delay: 300,
          easing: 'easeOutCirc',
          scrollTop:utils.getOffsetTop(cache.page.querySelector('.first_container')),
        });
      }
    };



    let switchTab = function() {
      let tab = this.dataset.tab;
      cache.postContainer2.innerHTML = "";
      filter = null;
      for (let i = 0; i < cache.tabs.length; i++) {
        if(cache.tabs[i].classList.contains('active')) {
          cache.tabs[i].classList.remove('active');
        }
        else {
          cache.tabs[i].classList.add('active');
        }
      }



      for (let i = 0; i < cache.filters.length; i++) {
        anime({
          targets: cache.filters[i],
          opacity: 0,
          duration: 100,
          delay:(20*i),
          easing: 'easeInOutCubic',
        });
      }

      for (let i = 0; i < cache.cards.length; i++) {
        anime({
          targets: cache.cards[i],
          opacity: 0,
          duration: 200,
          delay:(50*i),
          easing: 'easeInOutCubic',
          complete: function() {
            if(i == cache.cards.length-1) {
              // TAB All
                    if(tab == "all") {
                      tab1 = true;
                      for (let ii = 0; ii < cache.cards.length; ii++) {
                        if((ii < nbCardsTab1) && cache.cards[ii].classList.contains('hide_card')) {
                          cache.cards[ii].classList.remove('hide_card');
                        } else if((ii >= nbCardsTab1) && !cache.cards[ii].classList.contains('hide_card')) {
                          cache.cards[ii].classList.add('hide_card');
                        }
                      }

                      // RESET FILTERS
                      document.querySelector('.filter_all .nb_post').innerHTML = cache.cards.length;
                      for (var ii = 0; ii < cache.filters.length; ii++) {
                        if(!cache.filters[ii].classList.contains('filter_all')) {
                          if(cache.filters[ii].classList.contains('active')) {
                            cache.filters[ii].classList.remove('active');
                          }
                          let filter = cache.filters[ii].dataset.filter;
                          let nbPostFilter = cache.postContainer1.querySelectorAll('.'+filter).length;
                          if(nbPostFilter > 0) {
                            cache.filters[ii].querySelector('.nb_post').innerHTML = nbPostFilter;
                            cache.filters[ii].style.display = 'flex';
                          }
                        } else {
                          if(!cache.filters[ii].classList.contains('active')) {
                            cache.filters[ii].classList.add('active');
                          }
                        }
                      }

                      // SECTION 2
                      let cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card');
                      if(cards2.length > 0) {
                        cache.postContainer2.style.display = "grid";
                        for (var ii = 0; ii < cards2.length; ii++) {
                          let el = cards2[ii].cloneNode(true);
                          el.classList.remove('hide_card');
                          el.style.opacity = 1;
                          cache.postContainer2.appendChild(el);
                        }
                      } else {
                        cache.postContainer2.style.display = "none";
                      }
                    }

              // TAB 2
                    else {
                      tab1 = false;
                      let nbType = 0;
                      for (let ii = 0; ii < cache.cards.length; ii++) {
                        if(nbType < nbCardsTab2) {
                          if(cache.cards[ii].classList.contains('hide_card') && cache.cards[ii].classList.contains(type)) {
                            cache.cards[ii].classList.remove('hide_card');
                            nbType++;
                          } else if (!cache.cards[ii].classList.contains('hide_card') && cache.cards[ii].classList.contains(type)) {
                            nbType++;
                          } else {
                            cache.cards[ii].classList.add('hide_card');
                          }
                        } else {
                          cache.cards[ii].classList.add('hide_card');
                        }
                      }

                      // RESET FILTERS
                      document.querySelector('.filter_all .nb_post').innerHTML = cache.postContainer1.querySelectorAll('.'+type).length;
                      for (var ii = 0; ii < cache.filters.length; ii++) {
                        if(!cache.filters[ii].classList.contains('filter_all')) {
                          if(cache.filters[ii].classList.contains('active')) {
                            cache.filters[ii].classList.remove('active');
                          }
                          let filter = cache.filters[ii].dataset.filter;
                          let nbPostFilter = cache.postContainer1.querySelectorAll('.'+filter+'.'+type).length;
                          if(nbPostFilter > 0) {
                            cache.filters[ii].querySelector('.nb_post').innerHTML = nbPostFilter;
                          }
                          else {
                            cache.filters[ii].style.display = 'none';
                          }
                        } else {
                          if(!cache.filters[ii].classList.contains('active')) {
                            cache.filters[ii].classList.add('active');
                          }
                        }
                      }
                      // SECTION 2
                      let cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card.'+type);
                      if(cards2.length > 0) {
                        cache.postContainer2.style.display = "grid";
                        for (var ii = 0; ii < cards2.length; ii++) {
                          let el = cards2[ii].cloneNode(true);
                          el.classList.remove('hide_card');
                          el.style.opacity = 1;
                          cache.postContainer2.appendChild(el);
                        }
                      } else {
                        cache.postContainer2.style.display = "none";
                      }
                    }

                setTimeout(() => {
                  for (let i = 0; i < cache.filters.length; i++) {
                    anime({
                      targets: cache.filters[i],
                      opacity: 1,
                      duration: 200,
                      delay:(50*i),
                      easing: 'easeInOutCubic',
                    });
                  }
                  for (let i = 0; i < cache.cards.length; i++) {
                    anime({
                      targets: cache.cards[i],
                      opacity: 1,
                      duration: 200,
                      delay:(50*i),
                      easing: 'easeInOutCubic',
                    });
                  }
                }, 600)
            }
          }
        });
      }
    }


    let filterPost = function() {
      let maxPost = nbCardsTab1;
      if(!tab1) {
        maxPost = nbCardsTab2;
      }
      cache.postContainer2.innerHTML = "";
      document.querySelector('.filter_tag.active').classList.remove('active');
      this.classList.add('active');
      let t = this;
      let filter = t.dataset.filter;
      let cards;

      if(document.querySelector('.tab_wrap .tab.active').dataset.tab == "all") {
        cards = cache.cards;
      } else {
        cards = cache.postContainer1.querySelectorAll('.shop_card.'+type);
      }

      for (let i = 0; i < cache.cards.length; i++) {
        anime({
          targets: cache.cards[i],
          opacity: 0,
          duration: 200,
          delay:(50*i),
          easing: 'easeInOutCubic',
          complete: function() {
            if(i == cache.cards.length-1) {
              if(t.classList.contains('filter_all')) {
                for (let ii = 0; ii < cards.length; ii++) {
                  if((ii < maxPost) && cards[ii].classList.contains('hide_card')) {
                    cards[ii].classList.remove('hide_card');
                  } else if((ii >= maxPost) && !cards[ii].classList.contains('hide_card')) {
                    cards[ii].classList.add('hide_card');
                  }
                }
                // SECTION 2
                let cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card');
                if(!tab1) {
                  cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card.'+type);
                }
                if(cards2.length > 0) {
                  cache.postContainer2.style.display = "grid";
                  for (var ii = 0; ii < cards2.length; ii++) {
                    let el = cards2[ii].cloneNode(true);
                    el.classList.remove('hide_card')
                    el.style.opacity = 1;
                    cache.postContainer2.appendChild(el);
                  }
                } else {
                  cache.postContainer2.style.display = "none";
                }
              } else {
                let nbType = 0;
                for (let ii = 0; ii < cards.length; ii++) {
                  if(nbType < maxPost) {
                    if(cards[ii].classList.contains(filter) && cards[ii].classList.contains('hide_card')) {
                      cards[ii].classList.remove('hide_card');
                      nbType++;
                    } else if(cards[ii].classList.contains(filter) && !cards[ii].classList.contains('hide_card')) {
                      nbType++;
                    } else if(!cards[ii].classList.contains(filter) && !cards[ii].classList.contains('hide_card')) {
                      cards[ii].classList.add('hide_card');
                    }
                  } else {
                    cards[ii].classList.add('hide_card');
                  }
                }
                // SECTION 2
                let cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card.'+filter);
                if(!tab1) {
                  cards2 = cache.postContainer1.querySelectorAll('.shop_card.hide_card.'+type+'.'+filter);
                }
                if(cards2.length > 0) {
                  cache.postContainer2.style.display = "grid";
                  for (var ii = 0; ii < cards2.length; ii++) {
                    let el = cards2[ii].cloneNode(true);
                    el.classList.remove('hide_card');
                    el.style.opacity = 1;
                    cache.postContainer2.appendChild(el);
                  }
                } else {
                  cache.postContainer2.style.display = "none";
                }
              }
              setTimeout(() => {
                for (let i = 0; i < cache.cards.length; i++) {
                  anime({
                    targets: cache.cards[i],
                    opacity: 1,
                    duration: 200,
                    delay:(50*i),
                    easing: 'easeInOutCubic',
                  });
                }
              }, 100)
            }
          }
          })
        }

      if(tablet.matches) {
        openFilter();
        cache.filterDropBtn.querySelector('.txt').innerHTML = this.innerHTML;
      }
    }


    let openFilter = function() {
      if(cache.filterDropBtn.classList.contains('open')) {
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: 0,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: 0,
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDrop.style.display = "none";
            cache.filterDropBtn.classList.remove('open');
          }
        });
      } else {
        cache.filterDrop.style.display = "block";
        cache.filterDrop.style.height = "auto";
        let height = cache.filterDrop.offsetHeight;
        cache.filterDrop.style.height = 0;
        anime({
          targets: cache.filterDropBtn.querySelector('svg'),
          rotate: -180,
          duration: 400,
          easing: 'easeInOutCubic',
        });
        anime({
          targets: cache.filterDrop,
          height: [0,height],
          duration: 400,
          easing: 'easeInOutCubic',
          complete: function() {
            cache.filterDropBtn.classList.add('open');
          }
        });
      }
    }




    initFunc();
  };
}
export { Archive }
